import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const Plane2 = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="81" viewBox="0 0 67 81" width="67" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path d="M25.14 58.11 5.62 78.49 2.01 2.01s22.43 56.26 23.14 56.1z" fill={shades.white} />
      <path d="M64.33 17.2 40.47 42.11 2 2z" fill={shades.white} />
      <path d="M47.52 59.04s-21.83-1.5-22.38-.93c-.73 0-22.43-54.37-23.11-56.07l38.45 40.07z" fill={shades.primary.medium} />
      <path className={strokeStyle} d="M25.14 58.11 5.61 78.49 2.01 2z" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M47.53 59.04s-15.45-1.06-20.7-1.06c-.99 0-1.61.04-1.7.13L2 2l38.47 40.11z"
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m64.34 17.21-23.86 24.9L2.01 2z" strokeWidth={strokeWidth} />
    </svg>
  );
};
